import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import moment from 'moment';
import Currency from '../Currency';

import BaseConfirmationScreen from '../BaseConfirmationScreen';

import './styles.css';

const UnconnectedTransferConfirm = (props) => {
  const {
    transferFundsInfo,
  } = props;
  return (
    <BaseConfirmationScreen
      backLabel="Summary"
      backTo="/portfolio"
      confirmationText="Transfer Confirmed"
      header={`Transfer Confirmation Number: ${transferFundsInfo.eftOid}`}
    >
      <div styleName="transferConfirm">
        <div styleName="confirmRow">
          <div styleName="reviewLabels">Request Date</div>
          <div styleName="confirmDate">{moment(transferFundsInfo.requestDate).format('MMM DD, YYYY')}</div>
        </div>
        <div styleName="reviewLabels">From</div>
        <div styleName="reviewFields">{transferFundsInfo.fromLabel}</div>
        <div styleName="reviewLabels">To</div>
        <div styleName="reviewFields">{transferFundsInfo.toLabel}</div>
        <div styleName="reviewLabels">Transfer Amount</div>
        <Currency styleName="reviewAmount" amount={transferFundsInfo.TransferAmount} />
      </div>
    </BaseConfirmationScreen>
  );
};

const mapStateToProps = (state, props) => ({
  accountBankLinks: get(state, `accountBankLinks.[${props.accountNumber}].data`, []),
  transferFundsInfo: get(state, 'transferFundsInfo.transferInfo'),
});


export default connect(mapStateToProps, null)(UnconnectedTransferConfirm);



// WEBPACK FOOTER //
// ./src/components/TransferFunds/TransferConfirm.js